import $ from 'jquery';
jQuery.noConflict();

/* ============================================================
   SLIDE ANIMATION HELPERS (unchanged API)
   ============================================================ */

export function slideInFromRight(element, duration = 300, callback = null) {
    const $element = $(element);
    if ($element.length === 0) {
        console.warn('slideInFromRight: Element not found');
        return;
    }
    $element.css('display', 'block');
    setTimeout(() => {
        $element.addClass('slide-in');
        if (callback && typeof callback === 'function') {
            setTimeout(callback, duration);
        }
    }, 10);
}

export function slideOutToRight(element, duration = 300, callback = null) {
    const $element = $(element);
    if ($element.length === 0) {
        console.warn('slideOutToRight: Element not found');
        return;
    }
    $element.removeClass('slide-in').addClass('slide-out');
    setTimeout(() => {
        $element.css('display', 'none').removeClass('slide-out');
        if (callback && typeof callback === 'function') {
            callback();
        }
    }, duration);
}

export function toggleSlideAnimation(element, isVisible, duration = 300, callback = null) {
    if (isVisible) {
        slideOutToRight(element, duration, callback);
    } else {
        slideInFromRight(element, duration, callback);
    }
}

export function slideInFromLeft(element, duration = 300, callback = null) {
    const $element = $(element);
    if ($element.length === 0) {
        console.warn('slideInFromLeft: Element not found');
        return;
    }
    $element.css('display', 'block');
    setTimeout(() => {
        $element.addClass('slide-in-left');
        if (callback && typeof callback === 'function') {
            setTimeout(callback, duration);
        }
    }, 10);
}

export function slideOutToLeft(element, duration = 300, callback = null) {
    const $element = $(element);
    if ($element.length === 0) {
        console.warn('slideOutToLeft: Element not found');
        return;
    }
    $element.removeClass('slide-in-left').addClass('slide-out-left');
    setTimeout(() => {
        $element.css('display', 'none').removeClass('slide-out-left');
        if (callback && typeof callback === 'function') {
            callback();
        }
    }, duration);
}

/* ============================================================
   BODY SCROLL LOCK UTILITIES (unchanged API)
   ============================================================ */

export function lockBodyScroll() {
    const $body = $('body');
    const scrollY = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0;
    $body.css({
        position: 'fixed',
        top: `-${scrollY}px`,
        width: '100%',
        overflow: 'hidden'
    });
    $body.data('scroll-y', scrollY);
}

export function unlockBodyScroll() {
    const $body = $('body');
    const scrollY = $body.data('scroll-y') || 0;
    $body.css({
        position: '',
        top: '',
        width: '',
        overflow: ''
    });
    window.scrollTo(0, scrollY);
    $body.removeData('scroll-y');
}

/* ============================================================
   Unified Drawer System
   - works for span.cart.sidebar -> .block-cart
   - works for span.top-login.sidebar -> .block-account
   - export original cart functions as wrappers for compatibility
   ============================================================ */

/**
 * Resolve sidebar and dropdown elements.
 * Accepts:
 *  - selector string like 'span.cart.sidebar'
 *  - DOM/jQuery element inside dropdown (close button etc)
 * Returns object: { $sidebar, $dropdown }
 */
function getSidebarElements(selectorOrElement) {
    let $input;
    if (!selectorOrElement) {
        $input = $(); // empty jQuery
    } else if (selectorOrElement.jquery) {
        $input = selectorOrElement;
    } else {
        $input = $(selectorOrElement);
    }

    // If the provided element is not a sidebar itself, try to find the closest sidebar ancestor
    if ($input.length && !$input.is('span.cart.sidebar') && !$input.is('span.top-login.sidebar')) {
        const $closest = $input.closest('span.cart.sidebar, span.top-login.sidebar');
        if ($closest.length) {
            return {
                $sidebar: $closest,
                $dropdown: $closest.find('.block-cart, .block-account')
            };
        }
    }

    // If input is a sidebar (or empty), use it directly
    return {
        $sidebar: $input,
        $dropdown: $input.find('.block-cart, .block-account')
    };
}

/**
 * Lightweight per-sidebar click-lock (prevents double click triggering)
 * uses jQuery data attribute 'drawer-click-lock'
 */
function lockClick($sidebar, ms = 250) {
    if (!$sidebar || !$sidebar.length) return false;
    if ($sidebar.data('drawer-click-lock')) return false;
    $sidebar.data('drawer-click-lock', true);
    setTimeout(() => $sidebar.removeData('drawer-click-lock'), ms);
    return true;
}

/**
 * Check whether any drawer is currently open (selected)
 */
function anyDrawerOpen() {
    return $('span.cart.sidebar.selected, span.top-login.sidebar.selected').length > 0;
}

/**
 * Show overlay and hide helpers
 */
function showOverlayAndHelpers() {
    $('.wrapper-overlay-dark').show();
    $('.wrapper-overlay').hide();
    $('.pulldown').hide();
    $('.modal-mobile-signin').hide();
    $('.rootmenu-mobile').removeClass('open');
    $('.header.is-mobile').next().addClass('hidden');
}

/**
 * Hide overlay and restore helpers
 */
function hideOverlayAndHelpers() {
    $('.wrapper-overlay-dark').hide();
    // restore other helpers if necessary (we leave them hidden by default)
}

/* ============================
   Core unified open/close/toggle
   ============================ */

export function openDrawer(selectorOrElement) {
    const { $sidebar, $dropdown } = getSidebarElements(selectorOrElement);
    if (!$sidebar || !$sidebar.length) return;

    // Prevent rapid double-click
    if (!lockClick($sidebar)) return;

    if ($sidebar.hasClass('animating')) return;
    $sidebar.addClass('animating selected');

    // Close other sidebars
    $('span.cart.sidebar, span.top-login.sidebar').not($sidebar).removeClass('selected');

    // Lock body scroll
    lockBodyScroll();

    // Show overlay and helpers
    showOverlayAndHelpers();

    // Hide Tidio chat when drawer opens
    if (window.tidioChatApi) window.tidioChatApi.hide();
    $('#tidio-chat-iframe, #tidio-chat').hide();

    // Slide in dropdown
    slideInFromRight($dropdown, 300, () => {
        $sidebar.removeClass('animating');
    });
}

export function closeDrawer(selectorOrElement) {
    const { $sidebar, $dropdown } = getSidebarElements(selectorOrElement);
    if (!$sidebar || !$sidebar.length) {
        // if nothing provided, close all
        $('span.cart.sidebar.selected, span.top-login.sidebar.selected').each(function () {
            closeDrawer($(this));
        });
        return;
    }

    // Prevent double clicks
    if ($sidebar.data('drawer-click-lock')) return;

    if ($sidebar.hasClass('animating')) return;
    $sidebar.addClass('animating').removeClass('selected');

    slideOutToRight($dropdown, 300, () => {
        $sidebar.removeClass('animating');

        // Unlock body scroll
        unlockBodyScroll();

        // Hide overlay if no other drawer is open
        if (!anyDrawerOpen()) {
            hideOverlayAndHelpers();
        }

        // Show Tidio again
        if (window.tidioChatApi) window.tidioChatApi.show();
        $('#tidio-chat-iframe, #tidio-chat').show();
    });
}

export function toggleDrawer(selectorOrElement) {
    const { $sidebar } = getSidebarElements(selectorOrElement);
    if (!$sidebar || !$sidebar.length) return;

    if ($sidebar.hasClass('selected')) {
        closeDrawer($sidebar);
    } else {
        openDrawer($sidebar);
    }
}

/* ============================================================
   Backwards-compatible Cart-specific API (wraps unified functions)
   ============================================================ */

const drawerSelectors = 'span.cart.sidebar, span.top-login.sidebar';

export function openCartDrawer() {
    return openDrawer(drawerSelectors);
}

export function closeCartDrawer() {
    return closeDrawer(drawerSelectors);
}

export function toggleCartDrawer() {
    return toggleDrawer(drawerSelectors);
}

/*
 * Sidebar icon clicks are handled in header.js (critical bundle) to avoid two
 * delegated handlers toggling the same span and cancelling the "selected" state.
 * toggleCartDrawer / openDrawer / closeDrawer remain for programmatic use (e.g. checkout).
 */

// Delegated close button (handles clicks on button or any SVG/icon inside it)
$(document).on('click', '.cart-drawer-close1, .cart-drawer-close *', function (event) {
    event.preventDefault();
    event.stopPropagation();
    $('body').removeClass('noscrollactive');
    document.documentElement.classList.remove('noscroll');

    // find the dropdown (block-cart or block-account) and close its sidebar
    // const $block = $(this).closest('.block-cart, .block-account');
    // if ($block.length) {
    //     closeDrawer($block);
    // } else {
    //     // fallback - close any open drawer
    //     if ($('span.cart.sidebar.selected').length) closeDrawer('span.cart.sidebar');
    //     if ($('span.top-login.sidebar.selected').length) closeDrawer('span.top-login.sidebar');
    // }
});

// Overlay click closes any open drawer
$(document).on('click', '.wrapper-overlay-dark', function () {
    // if ($('span.cart.sidebar.selected').length) closeDrawer('span.cart.sidebar');
    // if ($('span.top-login.sidebar.selected').length) closeDrawer('span.top-login.sidebar');
    $('body').removeClass('noscroll');
    $('body').removeClass('noscrollactive');
    document.documentElement.classList.remove('noscroll');
});

// Close on ESC key
$(document).on('keydown', function (event) {
    if (event.key === 'Escape' || event.key === 'Esc') {
        // if ($('span.cart.sidebar.selected').length) closeDrawer('span.cart.sidebar');
        // if ($('span.top-login.sidebar.selected').length) closeDrawer('span.top-login.sidebar');
        $('body').removeClass('noscroll');
        $('body').removeClass('noscrollactive');
        document.documentElement.classList.remove('noscroll');
    }
});

// Click outside closes any open drawer (but not clicks inside dropdown or on sidebar)
$(document).on('click', function (event) {
    const $target = $(event.target);
    if ($target.closest('span.cart.sidebar, span.top-login.sidebar, .wrapper-overlay-dark').length === 0) {
        // clicked outside
        // if ($('span.cart.sidebar.selected').length) closeDrawer('span.cart.sidebar');
        // if ($('span.top-login.sidebar.selected').length) closeDrawer('span.top-login.sidebar');
        if ($('#topnav.active').length !== 1) {
            $('body').removeClass('noscroll');
            $('body').removeClass('noscrollactive');
            document.documentElement.classList.remove('noscroll');
        }
    }
});

/* ============================================================
   End of file
   ============================================================ */
